"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var gif_exports = {};
__export(gif_exports, {
  GifNode: () => GifNode
});
module.exports = __toCommonJS(gif_exports);
var import_core = require("@tiptap/core");
const GifNode = import_core.Node.create({
  name: "gif",
  group: "inline",
  inline: true,
  draggable: true,
  selectable: true,
  addAttributes() {
    return {
      "file-id": {
        default: null
      },
      src: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      },
      alt: {
        default: null
      }
    };
  },
  addCommands() {
    return {
      insertGif: /* @__PURE__ */ __name((attrs) => ({ commands }) => {
        return commands.insertContent({ type: this.name, attrs });
      }, "insertGif")
    };
  },
  parseHTML() {
    return [
      {
        // Above the default 50, so ImageNode's catch-all img[src] rule cannot claim a gif in
        // kits where image is enabled.
        tag: `img[data-type="${this.name}"]`,
        priority: 60
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    const imgAttributes = (0, import_core.mergeAttributes)({ "data-type": this.name }, HTMLAttributes);
    const fileId = imgAttributes["file-id"];
    if (fileId != null) {
      imgAttributes.src = `platform://platform/files/workspace/?file=${fileId}`;
    }
    return ["img", imgAttributes];
  }
});
//# sourceMappingURL=gif.js.map
